module.exports = __webpack_public_path__ + "images/category_lp/common/icon-step2_ecb3feee8e42c87eb209799fbaf8aa25.png";